import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Card, Col, Container, Input, Label, Row, Button } from 'reactstrap';
import AuthSlider from '../../../pages/AuthenticationInner/authCarousel';
import Pusher from 'pusher-js';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { saveStdInfo as onSaveStdInfo } from '../../../slices/exam/thunk';
import { isEmpty } from 'lodash';
import PagesLogoComponent from '../../../Components/Common/PagesLogoComponent';
import TimerComponent from '../timer/TimerComponent';
import { clearTimer } from '../../utility/TimerUtility';
import { questionListResetFlag } from '../../../slices/exam/thunk';

const Home = () => {

  document.title = "Theory Practice || Practice";

  const [examData, setExamData] = useState([])
  const [isStdHaveInfo, setIsStdHaveInfo] = useState(false);
  const [examInstructions, setExamInstruction] = useState('');
  const [storedSystemIp, steStoredSystemIp] = useState('')
  let navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    //    localStorage.clear();
    if (isEmpty(localStorage.getItem('systemLocalIp'))) {
      navigate('/system-start');
    }
    steStoredSystemIp(localStorage.getItem('systemLocalIp'))

    const pusher = new Pusher('797c52fa232a2f6149b8', {
      cluster: 'ap2'
    })

    const channel1 = pusher.subscribe('examData');
    channel1.bind_global(function (examData, data) {


      if (data && data.data) {

        if (localStorage.getItem('systemLocalIp') == data.data.systemIp) {
          window.localStorage.setItem("StudentInformation", JSON.stringify(data.data));
          setExamData(data.data);
          dispatch(onSaveStdInfo(data.data));
          setIsStdHaveInfo(true)
          steStoredSystemIp(localStorage.getItem('systemLocalIp'))

        }

      } else {
        setExamData([])
      }
      window.localStorage.removeItem('isStart');
      clearTimer();
      dispatch(questionListResetFlag())



    });
    return (() => {
      pusher.unsubscribe('examData')

    })

  }, []);





  return (
    <React.Fragment>
      <div className="auth-page-wrapper auth-bg-cover  d-flex justify-content-center align-items-center min-vh-100">
        <div className="bg-overlay"></div>
        <div className="auth-page-content overflow-hidden ">
          <PagesLogoComponent />

          <Container className=''>
            <Row>
              <Col lg={12}>

                <Card className="overflow-hidden ">

                  <Row className="g-0">

                    <div className="p-md- p-3 text-center">

                      <div>

                        <h3 className="text-primary">Welcome To {isStdHaveInfo ? examData && examData.courseName : ""} Theory Test</h3>
                        <h5 className="text-muted">Verify your information and  click Go button</h5>
                        <p className="text-muted">IP:{storedSystemIp}</p>
                      </div>
                      {isStdHaveInfo ?
                        <div>
                          <div style={{ fontSize: "20px" }}>
                            <span>Traffic ID: {examData && examData.trafficId}</span> <br />
                            <span>Student Name: {examData && examData.stdName}</span> <br />
                            <span>Question Language: {examData && examData.qLangFullName}</span> <br />
                            <span>Audio Language: {examData && examData.audioLangFullName}</span> <br />
                            <span>Course : {examData && examData.courseName}</span>

                          </div>
                        </div>
                        : ''}
                    </div>
                  </Row>
                  <Row className="g-0">
                    {examData.examType == 1 && examData.exam_instructions ?
                      <div className="p-md-5 p-4">
                        <div>
                          <h3 className="text-primary text-center">Instructions For Exam</h3>
                        </div>
                        <div>
                          <div className="mt-4">
                            <ul style={{ fontWeight: "bold", fontSize: "18px", paddingLeft: "20px", listStyleType: "disc" }}>
                              {examData.exam_instructions ? examData.exam_instructions.split("\n").map((line, index) => (
                                line.trim() && <li key={index}>{line}</li>
                              )) : <li>No instructions available</li>}
                            </ul>
                            {/* <p style={{ whiteSpace: "pre-line" }}>{examData && examData.exam_instructions ? examData.exam_instructions : ""}</p> */}
                          </div>
                        </div>
                      </div>
                      : ''}
                    {isStdHaveInfo ?
                      <div className="p-md-2 p-2">
                        {examData.examType == 1 ? (
                          examData.is_enable_exam_description == 1 ? (
                            <Link to="/instructions">
                              <Button color="primary" className="w-100" type="submit">Go</Button>
                            </Link>
                          ) : (
                            <Link to="/theory-practice">
                              <Button color="primary" className="w-100" type="submit">Go</Button>
                            </Link>
                          )
                        ) : examData.examType == 2 && examData.is_enable_p_description == 1 ? (
                          <Link to="/instructions">
                            <Button color="primary" className="w-100" type="submit">Go</Button>
                          </Link>
                        ) : (
                          <Link to="/practice-type">
                            <Button color="primary" className="w-100" type="submit">Go</Button>
                          </Link>
                        )}
                      </div>
                      : ''}
                  </Row>

                </Card>
              </Col>
            </Row>
          </Container>
        </div>



      </div>
    </React.Fragment>
  );
};

export default Home